import React, { useEffect, useState } from "react";
import Layout, { BaseScreenProps, StyledResults, StyledResultsLayout } from "./Layout";
import gql from "graphql-tag";
import { useCurrentUserContext } from "../hooks/useCurrentUser";
import useSnippetFilter from "../hooks/useSnippetFilter";
import { filterSnippets, getRefiners } from "../data/snippetsData";
import FilterPanel from "../components/snippets/FilterPanel";
import SnippetGroup from "../components/snippets/SnippetGroup";
import useApolloQueryWithCache from "../hooks/apollo/useApolloQueryWithCache";

export default function TagScreen({ tag }: TagScreenProps) {
  let { mySnippets, otherSnippets, filter, updateFilter, refiners } = useTag(tag);
  return (
    <Layout>
      <StyledResultsLayout>
        <FilterPanel
          filter={filter}
          updateFilter={updateFilter}
          excludes={["collections"]}
          refiners={refiners}
        />
        <StyledResults>
          {mySnippets.length > 0 && <SnippetGroup title="Mine" snippets={mySnippets} />}
          {otherSnippets.length > 0 && <SnippetGroup title="Community" snippets={otherSnippets} />}
        </StyledResults>
      </StyledResultsLayout>
    </Layout>
  );
}

export interface TagScreenProps extends BaseScreenProps {
  tag?: string;
}

const useTag = function(tag: string) {
  let { user } = useCurrentUserContext();
  let data = useApolloQueryWithCache(
    { query: TAG_SNIPPETS_QUERY, variables: { tag } },
    "tag-" + tag,
    200
  );

  // let { data, loading, error } = useApolloQuery(TAG_SNIPPETS_QUERY, { variables: { tag } });
  let { filter, updateFilter } = useSnippetFilter();
  let allSnippets = data && data.tag ? data.tag.snippets : [];

  let username = user ? user.username : null;

  let mySnippets = filterSnippets(
    filter,
    allSnippets.filter((s) => s.createdBy.username === username)
  );
  let otherSnippets = filterSnippets(
    filter,
    allSnippets.filter((s) => s.createdBy.username !== username)
  );

  return {
    mySnippets,
    otherSnippets,
    filter,
    updateFilter,
    refiners: getRefiners(allSnippets),
  };
};

const TAG_SNIPPETS_QUERY = gql`
  query GetSnippetsByTag($tag: String!) {
    tag(key: $tag) {
      snippets {
        title
        key
        filename
        path
        language {
          name
          key
        }
        description
        tags {
          key
        }
        createdBy {
          key
          username
          profilePhoto
        }
      }
    }
  }
`;
